module.exports = __webpack_public_path__ + "static/img/5我们的愿景.e965358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/5我们的愿景.png
// module id = 6tyO
// module chunks = 0